export default __webpack_public_path__ + "static/media/dialectPredictor.4f49132f.png";